import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import commonStyles from "../../../Utils/commonStyles";
import fieldTemplatesStyles from "../../Settings/FieldTemplatesSettings/FieldTemplatesStyles";
import { fget, fpatch, fpost } from "../../../API/callsAPI";
import SingleFieldView from "../../Settings/FieldTemplatesSettings/SingleFieldView";
import SingleTableView from "../../Settings/FieldTemplatesSettings/SingleTableView";

const EditTableViewModal = ({
  type,
  projectId,
  handleClose,
  refreshData,
  setSnackValue,
  editData,
}) => {
  const classes = fieldTemplatesStyles();
  const commonClasses = commonStyles();
  const [isCreateNewFieldModalOpen, setIsCreateNewFieldModalOpen] =
    useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [pageName, setPageName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedFieldsList, setSelectedFieldsList] = useState([]);

  const handleGetTemplates = async () => {
    try {
      const res = await fget({
        url: `/trackables/trackable-field/?project=${projectId}`,
      });

      setCustomFields(res?.data?.custom_fields);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetTemplates();
  }, [projectId]);

  const handleFieldClick = (field) => {
    if (selectedFieldsList?.length) {
      const isExist = selectedFieldsList?.some(
        (sin) => sin.name === field.name
      );
      if (isExist) {
        setSelectedFieldsList(
          selectedFieldsList.filter((sin) => sin.name !== field.name)
        );
      } else {
        setSelectedFieldsList([...selectedFieldsList, field]);
      }
    } else {
      setSelectedFieldsList([field]);
    }
  };

  const handleCreateNewPage = async () => {
    try {
      const addData = {
        url: `trackables/custom-page/`,
        data: {
          project: projectId,
          fields: selectedFieldsList?.map((item) => item.id),
          name: pageName,
          description,
        },
      };
      const res = await fpost(addData);
      if (res?.status === 200 || res?.status === 201) {
        setSnackValue({
          isOpen: true,
          message: `SuccessFully created new page`,
          isError: false,
        });
        refreshData();
        handleClose();
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: "Error On creating custom page",
        isError: true,
      });
    }
  };
  const handleUpdatePage = async () => {
    try {
      const addData = {
        url: `trackables/custom-page/${editData.id}/`,
        data: {
          project: projectId,
          fields: selectedFieldsList?.map((item) => item.id),
          name: pageName,
          description,
        },
      };
      const res = await fpatch(addData);
      if (res?.status === 200 || res?.status === 201) {
        setSnackValue({
          isOpen: true,
          message: `SuccessFully edited page`,
          isError: false,
        });
        refreshData();
        handleClose();
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: "Error On editing custom page",
        isError: true,
      });
    }
  };

  useEffect(() => {
    if (editData) {
      setPageName(editData.name);
      setDescription(editData.description);
      setSelectedFieldsList(editData.fields);
    }
  }, [editData, type]);

  return (
    <Card
      sx={{
        width: {
          md: "800px",
          lg: "1000px",
          xl: "1200px",
        },
        backgroundColor: "#1B1D28",
        color: "white",
        borderRadius: "20px",
        padding: "10px",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography sx={{ fontSize: "20px !important", fontWeight: 600 }}>
          Edit View
        </Typography>
        <Box>
          <SingleFieldView
            title="Custom Fields"
            showAddIcon={true}
            handleAddNew={() => setIsCreateNewFieldModalOpen(true)}
            fields={customFields}
            type="custom"
            onFieldClick={handleFieldClick}
            selectedFields={selectedFieldsList}
          />
        </Box>
        {selectedFieldsList?.length ? (
          <SingleTableView items={selectedFieldsList ?? []} />
        ) : (
          <Typography
            sx={{ color: "red", fontSize: "16px !important", fontWeight: 500 }}
          >
            Please Select Fields to create custom page
          </Typography>
        )}
        <CardActions className={classes.cardAction}>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              border: "2px solid #6C65D9",
              borderRadius: "10px",
              textTransform: "none",
              color: "white",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              type === "new" ? handleCreateNewPage() : handleUpdatePage();
            }}
            variant="contained"
            sx={{
              backgroundColor: "#6C65D9",
              borderRadius: "10px",
              textTransform: "none",
            }}
            disabled={!pageName || selectedFieldsList.length === 0}
          >
            {type === "new" ? "Create" : "Update"} Page
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};

export default EditTableViewModal;
